import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable no-nested-ternary */
import React from "react";
import { Tab, Tabs } from "@mui/material";
import { useScreenWidth } from "Root/profile/components/SubscriptionPageV2/hooks";
import styles from "./style.module.css";
const HTLPCarouselHeader = ({ className, items, setCurrentProduct, currentTabIndex, setCurrentTabIndex, }) => {
    const isMobile = useScreenWidth() < 768;
    const handleChange = (event, value) => {
        setCurrentTabIndex(value);
    };
    const onTabClick = (value) => {
        setCurrentProduct(value);
        window.scrollTo(0, 0);
    };
    return (_jsxs("div", { className: `${styles.main_header_container_dropdown} ${className}`, children: [_jsx("h4", { className: styles.sticky_header_title_mob, children: "Deep Dive into Your System" }), _jsx("h4", { className: styles.sticky_header_title, children: "Deep Dive into Your System" }), _jsx(Tabs, { value: currentTabIndex, onChange: handleChange, variant: isMobile
                    ? Object.keys(items).length > 3
                        ? "scrollable"
                        : "fullWidth"
                    : Object.keys(items).length > 3
                        ? "scrollable"
                        : "fullWidth", scrollButtons: isMobile ? false : "auto", classes: {
                    root: isMobile ? styles.root_scroller_mob : styles.root_scroller,
                    scroller: isMobile ? styles.scroller_mob : styles.scroller,
                    indicator: isMobile ? styles.indicator_mob : styles.indicator,
                    scrollButtons: styles.scrollButtons,
                }, children: items &&
                    Object.keys(items).map((item) => (_jsx(Tab, { style: { textTransform: "capitalize" }, onClick: () => onTabClick(item), label: items[item] && items[item].selector_str, classes: isMobile
                            ? Object.keys(items).length > 3
                                ? { selected: styles.selected_mob, root: styles.root_tab_mob_scrollable }
                                : { selected: styles.selected_mob, root: styles.root_tab_mob }
                            : Object.keys(items).length > 3
                                ? { selected: styles.selected, root: styles.root_tab_scrollable }
                                : { selected: styles.selected, root: styles.root_tab } }, item))) })] }));
};
export default HTLPCarouselHeader;
